import { cn } from "../../lib/utils";
import { LOGO_PATHS, LOGO_STYLES } from "./constants";
import { LogoProps } from "./types";

export const Logo = ({
  variant = "primary",
  className,
  href = "/",
}: LogoProps) => {
  const logoSrc =
    variant === "primary" ? LOGO_PATHS.primary : LOGO_PATHS.secondary;

  return (
    <a href={href} className={LOGO_STYLES.link}>
      <img
        src={logoSrc}
        title="Ticketón"
        alt="Ticketón icon"
        height={31}
        width={158}
        className={cn(className)}
        loading="lazy"
      />
    </a>
  );
};

Logo.displayName = "Logo";

export { Logo as default };
